import { render, staticRenderFns } from "./OrdenHeader.vue?vue&type=template&id=4de2ea54&scoped=true&"
import script from "./OrdenHeader.vue?vue&type=script&lang=js&"
export * from "./OrdenHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrdenHeader.vue?vue&type=style&index=0&id=4de2ea54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2ea54",
  null
  
)

export default component.exports